export const envVariables = {
  /**
   * Ip Address
   * @readonly
   * @const {ip}
   */
  ip: "https://www.grafixark.com/GrafixArk",
};
